// Registrace service workeru (sestavuje ho vite-plugin-pwa ze src/sw.ts jako /sw.js).
// Dřív ji vkládal plugin sám (registerSW.js); ruční registrace umožní přeskočit nativní WebView,
// kde service worker nic nepřináší (aplikace je zabalená, push jde nativně přes Capacitor).
import { isNative } from './native'

export const SERVICE_WORKER_URL = '/sw.js'

/** Zaregistruje service worker. Vrací false, když se registrace přeskočila (nativní aplikace, starý prohlížeč). */
export function registerServiceWorker(): boolean {
  if (typeof window === 'undefined' || isNative() || !('serviceWorker' in navigator)) return false
  const register = () => {
    navigator.serviceWorker
      .register(SERVICE_WORKER_URL, { scope: '/' })
      .catch((e) => console.warn('[sw] registrace se nepovedla', e))
  }
  if (document.readyState === 'complete') register()
  else window.addEventListener('load', register, { once: true })
  return true
}
